import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider, useSnackbar } from "notistack";

// Componente para manejar las notificaciones del service worker
// Componente para manejar las notificaciones del service worker
const ServiceWorkerWrapper = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  React.useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/sw.js")
          .then((registration) => {
            console.log("SW registrado con éxito:", registration.scope);

            // Detectar si hay un nuevo service worker esperando
            registration.addEventListener("updatefound", () => {
              const newWorker = registration.installing;
              if (newWorker) {
                newWorker.addEventListener("statechange", () => {
                  if (
                    newWorker.state === "installed" &&
                    navigator.serviceWorker.controller
                  ) {
                    console.log(
                      "Nuevo service worker esperando, mostrando notificación..."
                    );
                    enqueueSnackbar(
                      "Hay una nueva versión disponible. ¿Deseas actualizar ahora?",
                      {
                        variant: "info",
                        persist: true,
                        action: (key) => (
                          <div className="sw_update_container">
                            <button
                              className="sw_action_btn sw_update_btn"
                              onClick={() => {
                                newWorker.postMessage({ type: "SKIP_WAITING" });
                                enqueueSnackbar("Actualizando...", {
                                  variant: "success",
                                });
                                closeSnackbar(key);
                              }}
                            >
                              Actualizar
                            </button>
                            <button
                              className="sw_action_btn sw_dismiss_btn"
                              onClick={() => closeSnackbar(key)}
                            >
                              Ignorar
                            </button>
                          </div>
                        ),
                      }
                    );
                  }
                });
              }
            });

            // Escuchar mensajes del Service Worker
            navigator.serviceWorker.addEventListener("message", (event) => {
              // Nueva versión disponible
              if (event.data && event.data.type === "NEW_VERSION_AVAILABLE") {
                console.log("Nueva versión disponible:", event.data.version);
                enqueueSnackbar(
                  `Nueva versión disponible: ${event.data.version}`,
                  {
                    variant: "info",
                  }
                );
              }

              // Sincronización completada
              if (event.data && event.data.type === "SYNC_COMPLETED") {
                console.log("Sincronización completada:", event.data.message);
                enqueueSnackbar(event.data.message, {
                  variant: "success",
                });
              }

              // ✅ NUEVO: Duplicado detectado
              if (event.data && event.data.type === "DUPLICATE_DETECTED") {
                console.log("🔄 Duplicado detectado:", event.data.message);
                enqueueSnackbar(event.data.message, {
                  variant: "warning",
                  autoHideDuration: 5000,
                });
                
                // Opcional: Mostrar detalles del duplicado
                if (event.data.data) {
                  console.log("Detalles del duplicado:", {
                    id: event.data.data.id,
                    fechaOriginal: event.data.data.originalDate,
                    estado: event.data.data.status
                  });
                }
              }

              // ✅ NUEVO: Error de sincronización
              if (event.data && event.data.type === "SYNC_ERROR") {
                console.error("Error de sincronización:", event.data.error);
                enqueueSnackbar(
                  `Error: ${event.data.error}`,
                  {
                    variant: "error",
                    autoHideDuration: 6000,
                  }
                );
              }

              // Recargar página
              if (event.data && event.data.type === "RELOAD_PAGE") {
                console.log(
                  "Recargando página por actualización del service worker..."
                );
                window.location.reload();
              }
            });
          })
          .catch((error) => {
            console.error("Error al registrar el SW:", error);
          });
      });
    }
  }, [enqueueSnackbar, closeSnackbar]);

  return null;
};

const client = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={client}>
    {/* <ReactQueryDevtools/> */}
    <SnackbarProvider maxSnack={3} hideIconVariant={false} dense>
      <ServiceWorkerWrapper />
      <App />
    </SnackbarProvider>
  </QueryClientProvider>
);
